import { render, staticRenderFns } from "./VinculoAcompanhamento.vue?vue&type=template&id=e9ef74f4"
import script from "./VinculoAcompanhamento.vue?vue&type=script&lang=js"
export * from "./VinculoAcompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports